import React from 'react';
import {
    List,
    TextField,
    DateField,
    Pagination,
    Datagrid,
} from 'react-admin';
import { UserFilter, BasicButton, HEXSelectorField, UserLockoutField, CreateHSProfileButton, ResetPasswordButton} from './UserListComponents.jsx';
import { usePermissions } from 'react-admin';
import { ROLE_ADMIN, isInRole } from '../authProvider';

const UserList = (props) => {
    const { permissions } = usePermissions();
    const isAdmin = isInRole(ROLE_ADMIN, permissions);
    return (
        <List title="Users" exporter={false} {...props} sort={{ field: 'creationDate', order: 'DESC' }} filters={<UserFilter />} pagination={<Pagination rowsPerPageOptions={[10,25,50,100]} />}>
            <Datagrid>
                <TextField source="givenName" sortable={true} />
                <TextField source="surname" sortable={true} />
                <TextField source="company" sortable={true} />
                <TextField source="country" sortable={true} label="Country/Region" />
                <TextField source="city" sortable={true} />
                <DateField source="creationDate" sortable={true} showTime options={{ hour12: false }} />
                <DateField source="lastActivity" sortable={true} showTime options={{ hour12: false }} />
                <TextField source="lastSeenVersion" sortable={false} label="Last Seen Version" />
                <TextField source="email" sortable={true} />
                <HEXSelectorField label='HEXSelector' />
                <BasicButton label='Basic' />
                {isAdmin ? <UserLockoutField label="Lockout" /> : null}
                {isAdmin ? <CreateHSProfileButton label="HS Create" /> : null}
                {isAdmin ? <ResetPasswordButton label="Reset Password" /> : null}
            </Datagrid>
        </List>
    );
}

export default UserList;